import { LOCALE_DEFAULT } from "#cookie-control/constants";
import { useCookie } from "#imports";
export const getAllCookieIdsString = (moduleOptions) => getCookieIds([
  ...moduleOptions.cookies.necessary,
  ...moduleOptions.cookies.optional
]).join("");
export const getCookieIds = (cookies) => cookies.map((cookie) => cookie.id);
export const removeCookie = (name) => useCookie(name).value = void 0;
export const resolveTranslatable = (translatable, locale = LOCALE_DEFAULT) => {
  if (typeof translatable === "string") return translatable;
  if (!locale)
    throw new Error("No locale given for translatable that is not a string.");
  const result = translatable[locale];
  if (!result)
    throw new Error(`Could not get translation for locale ${locale}.`);
  return result;
};
export const useResolveTranslatable = (locale = LOCALE_DEFAULT) => {
  return (translatable) => resolveTranslatable(translatable, locale);
};
